import React, { useState, useEffect } from "react";
import barpannel from "../../style/components/bars/Bars.module.css";
import homepannel from "../../style/components/bars/HomePannel.module.css";
import SidePannelShimmer from "../ui/Loader/Shimmer/SidePannelShimmer";
import FallbackAvatar from "../ui/FallbackAvatar/FallbackAvatar";
import {
  getSelectedCompany,
  getSelectedPerson,
  getUserDetails,
} from "../../utils/auth";
import WebSocketOnline from "../../services/onlineSocketService";
import MainStyle from "../../style/Main.module.css";
const HomePannel = ({
  channels,
  directMessages: initialDirectMessages, // renamed to avoid conflict
  loading,
  onSelectConversation,
  onSelectedChannels,
}) => {
  const selected = getSelectedPerson();
  const user_details = getUserDetails();
  const [isExpandedChannel, setIsExpandedChannel] = useState(true);
  const [isExpandedChat, setIsExpandedChat] = useState(true);
  const [directMessages, setDirectMessages] = useState(initialDirectMessages); // local state
  const [imgErrors, setImgErrors] = useState({}); // Track errors per user
  const seletedCompany = getSelectedCompany();
  const apiUrl = process.env.REACT_APP_API_URL;

  const toggleChannels = () => setIsExpandedChannel((prev) => !prev);
  const toggleChat = () => setIsExpandedChat((prev) => !prev);

  useEffect(() => {
    if (!initialDirectMessages) return;

    const sortedMessages = [...initialDirectMessages].sort((a, b) => {
      // Move current user to the end
      if (a.register_id === user_details?.id) return 1;
      if (b.register_id === user_details?.id) return -1;
      return 0;
    });

    setDirectMessages(sortedMessages);
  }, [initialDirectMessages, user_details?.id]); // Only depend on id, not the whole user_details

  // Alternative simpler approach - remove the sort if not needed:
  // useEffect(() => {
  //   setDirectMessages(initialDirectMessages || []);
  // }, [initialDirectMessages]);

  useEffect(() => {
    WebSocketOnline.callbacks.onmessage = (data) => {
      if (data && data.type === "online_status") {
        const updatedStatuses = data.online_status;

        setDirectMessages((prevMessages) =>
          prevMessages.map((user) => {
            const updatedUser = updatedStatuses.find(
              (status) => status.id === user.register_id
            );
            if (updatedUser) {
              return { ...user, online_status: updatedUser.online_status };
            }
            return user;
          })
        );
      }
    };

    // return () => {
    //   WebSocketOnline.disconnect();
    // };
  }, []);

  const onSelectedPeople = (data) => {
    onSelectConversation({
      ...data,
      type: "dm",
    });
  };

  const onSelectedChannel = (data) => {
    onSelectedChannels({
      ...data,
      type: "channel",
    });
  };

  const handleImageError = (userId) => {
    setImgErrors((prev) => ({ ...prev, [userId]: true }));
  };

  return (
    <div className={barpannel.BarsContainer}>
      <div className={barpannel.BarsContainerChild}>
        <div className={homepannel.HomePannelHeading}>
          <h4>{seletedCompany?.company_name}</h4>
        </div>

        <div className={homepannel.ViewAllChatAndChannel}>
          {/* Channels Section */}
          <div className={homepannel.ChannelandchatList}>
            <div
              onClick={toggleChannels}
              className={homepannel.ChannelAndChatItem}
            >
              {isExpandedChannel ? "▾" : "▸"} # Channels
            </div>
            {isExpandedChannel && (
              <div className={homepannel.SubChannels}>
                {loading ? (
                  Array(4)
                    .fill()
                    .map((_, i) => (
                      <div
                        key={`channel-shimmer-${i}`}
                        style={{ margin: "8px 0" }}
                      >
                        <SidePannelShimmer width="200px" height="25px" />
                      </div>
                    ))
                ) : channels.length > 0 ? (
                  channels.map((channel) => (
                    <div
                      key={channel.id}
                      className={`${homepannel.ChatItemViewChannel}
              ${
                channel.is_group_chat === "channel" &&
                selected?.id === channel?.id
                  ? homepannel.ChatItemViewChannelActive
                  : ""
              }
              `}
                      onClick={() => onSelectedChannel(channel)}
                    >
                      <p>{channel.channel_name}</p>
                      {channel.unread_count > 0 && (
                        <div className={homepannel.UnreadContainer}>
                          <span className={homepannel.UnreadCount}>
                            {channel.unread_count}
                          </span>
                        </div>
                      )}
                    </div>
                  ))
                ) : (
                  <div className={homepannel.NoData}>No channels found....</div>
                )}
              </div>
            )}
          </div>

          {/* Direct Messages Section */}
          <div className={homepannel.ChannelandchatList}>
            <div onClick={toggleChat} className={homepannel.ChannelAndChatItem}>
              {isExpandedChat ? "▾" : "▸"} Direct Messages
            </div>
            {isExpandedChat && (
              <div className={homepannel.SubChannels}>
                {loading ? (
                  Array(8)
                    .fill()
                    .map((_, i) => (
                      <div
                        key={`dm-shimmer-${i}`}
                        className={homepannel.DMSkeleton}
                      >
                        <SidePannelShimmer
                          width="30px"
                          height="30px"
                          borderRadius="8px"
                        />
                        <SidePannelShimmer width="160px" height="25px" />
                      </div>
                    ))
                ) : directMessages.length > 0 ? (
                  directMessages.map((user) => (
                    <div
                      key={user.id}
                      className={`${homepannel.ChatItemView} ${
                        (user.is_group_chat === "0" &&
                          selected?.register_id === user?.register_id) ||
                        (user.is_group_chat !== "0" &&
                          selected?.group_id === user?.group_id)
                          ? homepannel.ChatItemActive
                          : ""
                      }`}
                      onClick={() => onSelectedPeople(user)}
                    >
                      <div className={MainStyle.ImageWrapper}>
                        {user.emp_pic && !imgErrors[user.register_id] ? (
                          <img
                            src={`${apiUrl}${user.emp_pic}`}
                            alt={user.name}
                            onError={() => handleImageError(user.register_id)}
                          />
                        ) : (
                          <FallbackAvatar name={user.name} size={30} />
                        )}

                        {user.is_group_chat === "0" &&
                          user.register_id !== user_details.id && (
                            <span
                              className={
                                user.online_status
                                  ? MainStyle.OnlineIndicator
                                  : MainStyle.OfflineIndicator
                              }
                            ></span>
                          )}
                      </div>
                      <p>
                        {user.name}
                        {user.register_id === user_details.id && (
                          <span style={{ color: "#888" }}> (You)</span>
                        )}
                      </p>
                      {user.unread_count > 0 && (
                        <div className={homepannel.UnreadContainer}>
                          <span className={homepannel.UnreadCount}>
                            {user.unread_count}
                          </span>
                        </div>
                      )}
                    </div>
                  ))
                ) : (
                  <div className={homepannel.NoData}>No DM found....</div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePannel;
